import { isAdvanced, isSimple, isEnterprise, backgroundColors } from 'config'
import React, { Component } from 'react'
import { Link } from 'react-router'
import { kea } from 'kea'
import styled from 'styled-components'
import DataLogic from 'containers/App/logic'

@kea({
  connect: {
    props: [DataLogic, ['finished', 'values']],
  },
})
export default class NavBar extends Component {
  render() {
    const { router, id } = this.props
    const { pathname } = this.props.router.getCurrentLocation()
    const pathContains = (v) => pathname.indexOf(v) !== -1

    const {
      profileFinished,
      habitationFinished,
      faturationFinished,
      consumeFinished,
    } = this.props.finished

    const { has_consumes } = this.props.values

    const classNames = (current, finished) => {
      let classes = ''

      if (current === '/') {
        if (pathname === '/') {
          classes += `current`
        }
      } else {
        if (pathContains(current)) {
          classes += `current`
        }
      }

      if (finished) {
        classes += ` finished`
      }

      return classes
    }

    return (
      <Wrapper id={id}>
        <ItemNoLink
          onClick={() => router.push('/#/')}
          className={classNames('/', profileFinished)}>
          <Number>1.&nbsp;</Number>
          <Text>Perfil {isEnterprise ? `da Empresa` : `do Consumidor`}</Text>
        </ItemNoLink>
        {(isAdvanced || isSimple) && (
          <Item
            to={`/habitacao`}
            className={classNames('habitacao', habitationFinished)}
            disabled={!profileFinished}>
            <Number>2.&nbsp;</Number>
            <Text>Minha Habitação</Text>
          </Item>
        )}
        <Item
          to={`/faturacao`}
          className={classNames('faturacao', faturationFinished)}
          disabled={!habitationFinished && !profileFinished}>
          <Number>{isEnterprise ? `2` : `3`}.&nbsp;</Number>
          <Text>Faturação e Fornecedores</Text>
        </Item>
        {(isAdvanced || has_consumes === true) && (
          <Item
            to={`/consumos`}
            className={classNames('consumos', consumeFinished)}
            disabled={
              !habitationFinished && !profileFinished && !faturationFinished
            }>
            <Number>4.&nbsp;</Number>
            <Text>Consumos</Text>
          </Item>
        )}
        {isEnterprise && (
          <Item
            to={`/consumos`}
            className={classNames('consumos', consumeFinished)}
            disabled={!profileFinished && !faturationFinished}>
            <Number>3.&nbsp;</Number>
            <Text>Consumos</Text>
          </Item>
        )}
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  margin: 0 auto;
  background-color: #bababa;
  max-height: 60px;
  z-index: 55;
`

const Item = styled(Link)`
  display: inline-block;
  text-align: center;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  height: 60px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  line-height: 60px;
  text-decoration: none;
  cursor: pointer;
  flex: 1;
  box-sizing: border-box;

  &.finished {
    background: #676767;
  }

  &.current {
    background: ${backgroundColors.normalLeft};
  }

  &:first-child {
    border-left: 0;
  }

  &:last-child {
    border: 0;
  }

  @media screen and (max-width: 568px) {
    line-height: initial;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex-direction: column;
    padding-top: 10px;
  }

  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
    opacity: 0.7;
  `}
`

const ItemNoLink = styled.div`
  display: inline-block;
  text-align: center;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  height: 60px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  line-height: 60px;
  text-decoration: none;
  cursor: pointer;
  flex: 1;
  box-sizing: border-box;

  &.finished {
    background: #676767;
  }

  &.current {
    background: ${backgroundColors.normalLeft};
  }

  &:first-child {
    border-left: 0;
  }

  &:last-child {
    border: 0;
  }

  @media screen and (max-width: 568px) {
    line-height: initial;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding-top: 10px;
  }
`
const Text = styled.span`
  @media screen and (max-width: 568px) {
    display: block;
    font-size: 8px;
  }
`

const Number = styled.span``



// WEBPACK FOOTER //
// ./src/containers/Navbar/index.js